import React from 'react'
import PropTypes from 'prop-types'
import VideoIframeRenderer from './VideoIframeRenderer'
import { VIDEO_FORMATS } from 'shared/helpers/VideoUrlsHelper'

const Prezi = ({ item }) => {
  return <VideoIframeRenderer
    url={item.link_url}
    type={VIDEO_FORMATS.prezi}
    title="Viewer: Prezi item" />
}

Prezi.propTypes = {
  item: PropTypes.object.isRequired
}

export default Prezi